<template>
    <div class="p-0 mb-4">
        <p class="mb-1">
            <span v-if="canRemove" class="text-danger small clickable" @click="markPresent(student, false)">remove</span>
           {{ student.grade }}<small>th</small> {{ student.name }} 
           <span class="badge badge-warning badge-pill">{{ student.detentionCounter }} {{student.detentionCounter > 1 ? "detentions" : "detention"}}
           </span>
            <button v-if="canMarkPresent" class="btn btn-sm btn-outline-success py-0 px-1 ml-3" @click="markPresent(student, true)">Mark present</button>
        </p>
        <div>
            <div class="flex-direction-column p-1 text-center">
            <div class="m-0 p-0" v-for="(detention, key) in student.detentions" :key="detention.id">
                <span class="badge badge-info mr-1 clickable" @click="changeDetentionType(student, key)">{{ detention.type }}</span>
                <span>{{ detention.descr || detention }}</span>                
            </div>
            </div>
      
        </div>
    </div>
   
</template>

<script>
import Firebase from 'firebase/app'
import { db } from '@/main.js'

export default {
    name: "Detention",
    props: ["student", "detentionTypes"],
    methods: {
        markPresent: function(student, countIt) {
            var studentRef = db.collection('students').doc(student.id);
            if (countIt) {
                this.recordDetention(student);
            }
            if (student.detentionCounter > 1) {
                return studentRef.update({
                    detentionCounter : Firebase.firestore.FieldValue.increment(-1)
                })
            } else {
                return studentRef.update({
                    detentionCounter : 0,
                    detentions : []
                })
            }
        },
        recordDetention: async function(student) {
            var studentRef = await db.collection('detentions').doc(student.id).get()
            const timestamp = Firebase.firestore.Timestamp.fromDate(new Date(Date.now()))
            if (studentRef.exists) {
                var reasons = []
                student.detentions.forEach(d => {
                    if (d.descr) {
                        reasons.push(d.descr)
                    } else {
                        reasons.push(d)
                    }
                })
                studentRef.ref.update({
                    detentionRecord: Firebase.firestore.FieldValue.arrayUnion(
                        {date: timestamp, reasons: reasons})
                })
            } else {
                studentRef.ref.set({
                    student: db.collection('students').doc(student.id),
                    detentionRecord: [{date: timestamp, reasons: student.detentions}],
                    org: this.$root.sharedState.org
                })
            }
            this.$toasted.show(student.name + " marked present")
        },
        changeDetentionType: function(student, detentionId) {
            if (this.canRemove) {
                let oldIndex = this.detentionTypes.indexOf(student.detentions[detentionId].type)
                let newDetentionType = this.detentionTypes[(oldIndex + 1) % this.detentionTypes.length]
                student.detentions[detentionId].type = newDetentionType
                db.collection('students').doc(student.id).update({
                    detentions: student.detentions
                })
            }
        },
    },
    computed: {
        canMarkPresent: function() {
            return this.$root.sharedState.accessLevel >= 4
        },
        canRemove: function() {
            return this.$root.sharedState.accessLevel >= 3
        }       
    }
}
</script>
